import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { treatmentApi } from "../../api/endpoints.js";
import { AdultScreen, AdultHeader, Content } from "../../components/Layout.js";
import { Card } from "../../components/Card.js";
import { Button } from "../../components/Button.js";
import { Loader } from "../../components/Loader.js";
import { ErrorBanner, InfoBanner } from "../../components/Form.js";
import { useQuery } from "../../hooks/useQuery.js";
import { useT } from "../../i18n/index.js";
import { PracticePlayer } from "./PracticePlayer.js";

export function PracticePage() {
  const t = useT();
  const { childId = "" } = useParams();
  const { data: planes, loading, error, reload } = useQuery(
    () => treatmentApi.planesPorNino(childId),
    [childId],
  );
  const [activo, setActivo] = useState<string | null>(null);

  if (activo) {
    return <PracticePlayer planId={activo} onExit={() => setActivo(null)} />;
  }

  return (
    <AdultScreen>
      <AdultHeader title={t("practice.title")} />
      <Content>
        {loading ? <Loader /> : null}
        {error ? <ErrorBanner message={error} /> : null}

        {planes && planes.length === 0 ? (
          <InfoBanner>
            Aún no hay un plan de práctica. Genera uno desde el reporte de una
            evaluación completada.
          </InfoBanner>
        ) : null}

        {planes?.map((p) => (
          <Card key={p.id}>
            <h2>Plan {p.origen === "auto" ? "automático" : "del terapeuta"}</h2>
            <p>
              Estado: {p.estado} · umbral tolerante {Math.round(p.umbralTolerante * 100)}%
            </p>
            {p.disclaimer ? <InfoBanner tone="warn">{p.disclaimer}</InfoBanner> : null}
            <Button block style={{ marginTop: 10 }} onClick={() => setActivo(p.id)}>
              {t("practice.start")}
            </Button>
          </Card>
        ))}

        <Button variant="ghost" onClick={reload}>
          {t("common.retry")}
        </Button>
        <Link to="/padre" style={{ textAlign: "center" }}>
          {t("common.back")}
        </Link>
      </Content>
    </AdultScreen>
  );
}
